// Pre-owned interest checkboxes: keep the checked machine models in sync with
// the hidden "Machine(s) Interested In" field (input_12_10) on the hero's form.
const preOwnedInterest = $('.block-pre-owned-card .js-interest-checkbox');

if (preOwnedInterest.length) {

    const syncPreOwnedInterest = function() {

        const models = preOwnedInterest.filter(':checked').map(function() {
            return $(this).data('model');
        }).get();

        $('#input_12_10').val(models.join(', '));
    };

    preOwnedInterest.on('change', syncPreOwnedInterest);

    // Gravity Forms AJAX rebuilds the form markup after a validation error or
    // submission, so the hidden field has to be repopulated on each re-render.
    $(document).on('gform_post_render', syncPreOwnedInterest);
}
